// extracted by mini-css-extract-plugin
export default {"cls1":"MultiPaperNewsStory-cls1___c5e8f1dfc3379bc7bc8","cls2":"MultiPaperNewsStory-cls2___52aba63ad472ecc8a49 MultiPaperNewsStory-cls1___c5e8f1dfc3379bc7bc8"};